import Hammer from 'hammerjs';
import FinishesColors from './finishes-colors';
const MaterialCards = () => {
  const body = document.body;
  const materialCards = [...document.querySelectorAll(".material-cards__item")];

  if (materialCards.length > 0) {
    materialCards.forEach((materialCard) => {
      const modalWrapper = document.querySelector(".material-cards__modal-wrapper");
      const material = materialCard.getAttribute("data-material");

      if (modalWrapper) {  
        const closer = modalWrapper.querySelector(".material-cards__modal-closer");
        const primaryTabs = [...modalWrapper.querySelectorAll(".material-cards__modal-tabs-primary .tab")];
        const secondaryTabsGroups = [...modalWrapper.querySelectorAll(".material-cards__modal-tabs-secondary")];  
        const modalMains = [...modalWrapper.querySelectorAll(".material-cards__modal-main")];

        let selectedMaterial = material; 
        let selectedProcess = null;    
        

        const updatePrimaryTab = (tabs, materialToActivate) => {
          tabs.forEach((tab) => {
            const isActive = tab.getAttribute("data-material") === materialToActivate;
            tab.classList.toggle("active", isActive);
          });
        };

        const handlePrimaryTabClick = (tab) => {
          selectedMaterial = tab.getAttribute("data-material");
          
          updatePrimaryTab(primaryTabs, selectedMaterial);
        
          updateSecondaryTabsGroup(secondaryTabsGroups, selectedMaterial);
        
          const activeSecondaryTabsGroup = secondaryTabsGroups.find(group => 
            group.getAttribute("data-material") === selectedMaterial
          );
          if (activeSecondaryTabsGroup) {
            const secondaryTabs = [...activeSecondaryTabsGroup.querySelectorAll(".tab")];
            handleSecondaryTabs(secondaryTabs); 
          }
        
        };

        const updateSecondaryTabsGroup = (groups, materialToActivate) => {
          groups.forEach((group) => {
            const isActive = group.getAttribute("data-material") === materialToActivate;
            group.classList.toggle("active", isActive);
          });
        };

        const updateModalMains = (material, process) => {
          modalMains.forEach((main) => {
            const isActive = main.getAttribute('data-material') === material && main.getAttribute('data-process') === process;
            main.classList.toggle("active", isActive);
          });
        };        

        const handleSecondaryTabs = (secondaryTabs) => {
          if (secondaryTabs.length > 0) {
            secondaryTabs.forEach((tab) => tab.classList.remove("active"));
            secondaryTabs[0].classList.add("active");

            selectedProcess = secondaryTabs[0].getAttribute('data-process');
            updateModalMains(selectedMaterial, selectedProcess);

            secondaryTabs.forEach((secondaryTab) => {
              secondaryTab.addEventListener("click", (event) => {
              
                secondaryTabs.forEach((tab) => tab.classList.remove("active"));
                secondaryTab.classList.add("active");

                selectedProcess = secondaryTab.getAttribute('data-process'); 
                let currentMaterial = event.currentTarget.getAttribute("data-material");
                FinishesColors();
                updateModalMains(currentMaterial, selectedProcess);
              });
            });
          }
        };

        const initSwipeToClose = (modalWrapper) => {
          const hammer = new Hammer(modalWrapper);
          hammer.get('swipe').set({ direction: Hammer.DIRECTION_VERTICAL });

          hammer.on('swipedown', () => {
            modalWrapper.classList.remove('opened');
            body.classList.remove('no-scroll');
          });
        };

        const openModal = (opener) => {
          modalWrapper.classList.add("opened");
          body.classList.add('no-scroll');
          let activeMaterial = opener.getAttribute('data-material');
          FinishesColors();
          
          updatePrimaryTab(primaryTabs, activeMaterial);

          updateSecondaryTabsGroup(secondaryTabsGroups, activeMaterial);
          const modalTabsSecondary = document.querySelector(`.material-cards__modal-tabs-secondary[data-material="${activeMaterial}"]`);
          let activeProcess = null;
          if (modalTabsSecondary) {
              const firstTab = modalTabsSecondary.querySelector(".tab");
              if (firstTab) {
                  modalTabsSecondary.querySelectorAll(".tab").forEach((tab) => tab.classList.remove("active"));
                  firstTab.classList.add("active");
                  activeProcess = firstTab.getAttribute("data-process");
              }
          }
          updateModalMains(activeMaterial, activeProcess);
        };

        const closeModal = () => {
          modalWrapper.classList.remove("opened");
          body.classList.remove('no-scroll');
        };
        modalWrapper.addEventListener("click", (event) => {
          if (event.target === modalWrapper || event.target === document.querySelector(".material-cards__modal-header")) {
            closeModal();
          }
        });
        if (closer) {
          closer.addEventListener("click", closeModal);
        }

        materialCards.forEach((opener) => {
          opener.addEventListener("click", () => openModal(opener) );
          FinishesColors();
          const link = opener.querySelector('a');
          if (link) {
              link.addEventListener('click', (event) => {
                  event.stopPropagation(); 
              });
          }
        });

        primaryTabs.forEach((tab) => {
          tab.addEventListener("click", () => handlePrimaryTabClick(tab));
          FinishesColors();
        });

        secondaryTabsGroups.forEach((group) => {
          const secondaryTabs = [...group.querySelectorAll(".tab")];
          handleSecondaryTabs(secondaryTabs);
        });

        initSwipeToClose(modalWrapper);
      }
    });
  }
};

export default MaterialCards;
